import { render, staticRenderFns } from "./SwiperOccupation.vue?vue&type=template&id=3bc03ee8&"
import script from "./SwiperOccupation.vue?vue&type=script&lang=js&"
export * from "./SwiperOccupation.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports